import React, { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import { Helmet } from "react-helmet"
import { Grid, Divider, Dialog } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import * as Adm from "@adm"
import { useSelector } from "react-redux"
import FirstEleDetails from "./firstEleDetails"
import OtherDetails from "./otherDetails"
import { getTurnstileDetailsByID } from "../../api/turnstileApi"
import {
  deleteTurnstile,
  getDeleteErrorMessage,
  MAPPED_DEVICES_MSG,
} from "../../api/entryorexitgateApi"
import {
  getLocationList,
  setSmartDeviceApiSuccessToggle,
} from "../../../../reduxSagas/admin/actions"
import { connect } from "react-redux"
import HierarchyMapping from "../../../masterData/HierarchyMapping"
import _ from "lodash"
import { withStyles } from "@material-ui/core/styles"
import { editTurnstileApi } from "../../api/turnstileApi"
import { ConfirmationDialog, NewConfirmationDialog } from "@features"
import { useHistory, Prompt } from "react-router-dom"

const StyledDialog = withStyles((theme) => ({
  paper: {
    maxHeight: "calc(100vh - 70px) !important",
    minWidth: "90vw !important",
    maxWidth: "98vw !important",
    padding: "0px",
    "@media(max-width:1200px)": {
      minWidth: "calc(100% - 80px) !important",
      maxWidth: "calc(100% - 80px) !important",
    },
  },
}))(Dialog)

const useStyles = makeStyles({})

const EditTurnstile = ({
  createTurnstile,
  setSmartDeviceApiSuccessToggle,
  isWriteAllowed,
  isDeleteAllowed,
}) => {
  const classes = useStyles()
  const history = useHistory()
  const { turnstileId, LocationNum } = useParams()
  const userProfileDetails =
    useSelector((state) => state.adminReducer.userProfileDetails) || {}
  const [dropDownList, setDropDownList] = useState([
    "Select Store",
    LocationNum,
  ])
  const [isDedupeOpen, setDedupeOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isAnyChanges, setAnyChanges] = React.useState(false)
  const [stores1, setStores1] = React.useState([])
  const [alertType, setAlertType] = React.useState("")
  const [alert, setAlert] = React.useState(false)
  const [alertMessage, setAlertMessage] = React.useState("")
  const BreadcrumbList = [
    {
      name: "Autonomous Store",
      disable: true,
    },
    {
      name: "Device Config",
      disable: true,
    },
    {
      name: "Turnstile",
      url: `/${userProfileDetails?.roleType}/autonomous-store/sdc/turnstile`,
    },
    {
      name: turnstileId && turnstileId,
    },
  ]
  const flag = useSelector((state) => state.loginstateReducer)
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false)
  const [openDeleteConfirmationDialog, setOpenDeleteConfirmationDialog] =
    useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [reDirect, setReDirect] = useState(false)
  const [pathName, setPathName] = useState("/")
  const [allowPrompt, setAllowPrompt] = useState(false)
  const [cancel, setCancel] = useState("")
  const [turnstileDetails, setTurnstileDetails] = useState({
    turnstileID: null,
    turnstileName: "",
    turnstileIP: null,
    prevLoc: "None",
    LocNum: LocationNum && LocationNum,
    turnstileloc: "",
    turnstileport: null,
    location: null,
    entryCoordinatesX: null,
    entryCoordinatesY: null,
    exitCoordinatesX: null,
    exitCoordinatesY: null,
    entryResettime: null,
    exitResettime: null,
    saveLoc: LocationNum && LocationNum,
    ResetTime: null,
    CoordinatesX: null,
    CoordinatesY: null,
    locationType: null,
    locationName: null,
    device_mapped: false,
  })
  const [selectedLocationList, setSelectedLocationList] = useState([])
  const [locType, setLocType] = useState("")
  const [sdcFilter, setSdcFilter] = useState([])
  useEffect(() => {
    getTurnstileDetails(turnstileId, LocationNum)
    setLoading(true)
  }, [turnstileId, LocationNum])

  const getTurnstileDetails = async () => {
    const newTurnstileDetails = { ...turnstileDetails }
    await getTurnstileDetailsByID(turnstileId, LocationNum, setLoading)
      .then((res) => {
        if (
          res &&
          res.data &&
          res.data.data &&
          res.data.data &&
          res.data.data.turnstile &&
          res.data.data.turnstile[0]
        ) {
          newTurnstileDetails.LocNum = LocationNum && LocationNum
          newTurnstileDetails.turnstileName =
            res.data.data.turnstile[0]?.turnstileName
          newTurnstileDetails.turnstileID =
            res.data.data.turnstile[0].turnstileId
          newTurnstileDetails.turnstileIP =
            res.data.data.turnstile[0].turnstileIp
          newTurnstileDetails.turnstileloc =
            res.data.data.turnstile[0].installLocation
          newTurnstileDetails.turnstileport =
            res.data.data.turnstile[0].turnstilePort
          newTurnstileDetails.location = res.data.data.turnstile[0].location
          newTurnstileDetails.CoordinatesX =
            res.data.data.turnstile[0].coordinates[0]
          newTurnstileDetails.CoordinatesY =
            res.data.data.turnstile[0].coordinates[1]
          newTurnstileDetails.ResetTime = res.data.data.turnstile[0].resetTime
          newTurnstileDetails.locationType =
            res.data.data.turnstile[0].locationDetails[0]?.locationType?.name
          newTurnstileDetails.locationName =
            res.data.data.turnstile[0].locationDetails[0]?.locationName
          newTurnstileDetails.device_mapped =
            res.data.data.turnstile[0]?.device_mapped ?? false
          setLocType(
            res.data.data.turnstile[0].locationDetails[0]?.locationType?.name
          )
          setSelectedLocationList([
            res.data?.data?.turnstile[0]?.locationDetails,
          ])
        }
        setTurnstileDetails(newTurnstileDetails)
      })
      .catch((err) => {
        if (err?.response?.status === 404) {
          history.push(
            `/${userProfileDetails?.roleType}/auth/${err?.response?.status}`
          )
        }
      })
    await setLoading(false)
  }
  useEffect(() => {
    if (flag) {
      setOpenConfirmationDialog(false)
      setOpenDeleteConfirmationDialog(false)
    }
  }, [flag])

  useEffect(() => {
    setDropDownList(["Select Store", turnstileDetails.LocNum])
  }, [turnstileDetails.LocNum])

  const handleReset = (pathName) => {
    if (pathName) {
      history.push(pathName)
    } else {
      history.push("/")
    }
  }
  useEffect(() => {
    if (reDirect) {
      handleReset(pathName)
    }
  }, [reDirect])
  useEffect(() => {
    if (createTurnstile) {
      setAlertMessage(`Turnstile ID ${turnstileId} is Successfully Saved`)
      setAlert(false)
      setAlertType("success")
      setSmartDeviceApiSuccessToggle(false, "createTurnstile")
    }
  }, [createTurnstile])

  const handleDedupeModal = (val) => {
    if (val === "Select Store") {
      let filterVal = []
      if (locType === "Store") {
        filterVal = ["Warehouse", "Decommission"]
      } else if (locType === "Warehouse") {
        filterVal = ["Store", "Warehouse", "Decommission"]
      } else if (locType === "Decommission") {
        filterVal = ["Decommission"]
      }
      setSdcFilter([
        { field: "locationType.name", operator: "eq", value: filterVal },
      ])
      setDedupeOpen(true)
    } else {
      const newTurnstileDetails = { ...turnstileDetails }
      newTurnstileDetails.LocNum = val
      setTurnstileDetails(newTurnstileDetails)
    }
  }

  const handleDedupeClose = () => {
    setDedupeOpen(false)
  }
  const handleInputChange = (e) => {
    const newTurnstileDetails = { ...turnstileDetails }
    newTurnstileDetails[e.target.name] = e.target.value
    setTurnstileDetails(newTurnstileDetails)
  }
  const handleInputDropdownChange = (val) => {
    const newTurnstileDetails = { ...turnstileDetails }
    newTurnstileDetails["turnstileloc"] = val
    setTurnstileDetails(newTurnstileDetails)
  }
  const onDialogSubmit = (selectedItems, callback) => {
    const newDropDownList = [...dropDownList]
    const newTurnstileDetails = { ...turnstileDetails }
    let selectedIds = selectedItems.map((x) => _.get(x, "locationId"))
    newTurnstileDetails.prevLoc = newTurnstileDetails.saveLoc
    newTurnstileDetails.LocNum = selectedIds[0]
    newTurnstileDetails.locationType = selectedItems[0].locationType?.name
    newTurnstileDetails.locationName = selectedItems[0].locationName
    newDropDownList.pop()
    newDropDownList.push(selectedIds[0])
    setStores1(selectedIds)
    setSelectedLocationList(selectedItems)
    if (_.isFunction(callback)) callback()
    setTurnstileDetails(newTurnstileDetails)
    setDropDownList(newDropDownList)
    setDedupeOpen(false)
    setAnyChanges(true)
  }
  const discardChangesOfFirstEle = async () => {
    await setLoading(true)
    await setAllowPrompt(false)
    const newDropDownList = [...dropDownList]
    const newTurnstileDetails = { ...turnstileDetails }
    setTimeout(() => {
      getTurnstileDetails(turnstileId, newTurnstileDetails.saveLoc)
    }, 500)
  }
  const discardChangesOfOtherEle = async () => {
    const newDropDownList = [...dropDownList]
    const newTurnstileDetails = { ...turnstileDetails }
    const res = await getTurnstileDetailsByID(
      turnstileId,
      newTurnstileDetails.saveLoc
    )
    if (
      res &&
      res.data &&
      res.data.data &&
      res.data.data &&
      res.data.data.turnstile &&
      res.data.data.turnstile[0]
    ) {
      newTurnstileDetails.turnstileport =
        res.data.data.turnstile[0].turnstilePort
      newTurnstileDetails.CoordinatesX =
        res.data.data.turnstile[0].coordinates[0]
      newTurnstileDetails.CoordinatesY =
        res.data.data.turnstile[0].coordinates[1]
      newTurnstileDetails.ResetTime = res.data.data.turnstile[0].resetTime
      newTurnstileDetails.locationType =
        res.data.data?.turnstile[0].locationDetails?.locationType?.name
      newTurnstileDetails.locationName =
        res.data.data?.turnstile[0].locationDetails?.locationName
      newTurnstileDetails.LocNum = newTurnstileDetails.saveLoc
      newDropDownList.pop()
      newDropDownList.push(newTurnstileDetails.saveLoc)
    }
    setDropDownList(newDropDownList)
    setTurnstileDetails(newTurnstileDetails)
  }
  const editApi = async (
    turnstileDetails,
    history,
    setAlertMessage,
    setAlert,
    setAlertType,
    setLoading,
    setEdit
  ) => {
    const newTurnstileDetails = { ...turnstileDetails }
    const res = await editTurnstileApi(
      turnstileDetails,
      history,
      setAlertMessage,
      setAlert,
      setAlertType,
      setLoading,
      setEdit
    )
    if (res) {
      newTurnstileDetails.prevLoc = "None"
      newTurnstileDetails.saveLoc = newTurnstileDetails.LocNum
      setTurnstileDetails(newTurnstileDetails)
      getTurnstileDetailsByID(
        turnstileDetails?.turnstileID,
        turnstileDetails?.LocNum
      )
    }
  }
  const onCloseHandlerToMakeDefaultValues = () => {
    setAlertType("")
    setAlert(false)
    setAlertMessage("")
  }
  const handleCustomCloseRedirect = () => {
    setOpenConfirmationDialog(false)
  }

  const showMappedDevicesError = () => {
    setAlertType("error")
    setAlertMessage(MAPPED_DEVICES_MSG)
    setAlert(true)
  }

  const handleDeleteConfirm = async () => {
    try {
      setDeleteLoading(true)
      setLoading(true)
      await deleteTurnstile(LocationNum, turnstileId)
      history.push({
        pathname: `/${userProfileDetails?.roleType}/autonomous-store/sdc/turnstile`,
        state: {
          successMessage: "Turnstile deleted successfully.",
        },
      })
    } catch (error) {
      setAlertType("error")
      setAlertMessage(getDeleteErrorMessage(error))
      setAlert(true)
    } finally {
      setDeleteLoading(false)
      setLoading(false)
      setOpenDeleteConfirmationDialog(false)
    }
  }

  const setAllowPromptCheck = (value) => {
    if (value !== null) {
      setAllowPrompt(true)
    }
  }
  return (
    <>
      <Helmet title={"EditTurnstile Details"} />
      <Adm.BackdropOverlay open={loading} />
      <ConfirmationDialog
        openConfirmationDialog={openConfirmationDialog}
        setOpenConfirmationDialog={setOpenConfirmationDialog}
        setReDirect={setReDirect}
        setCancel={setCancel}
        handleCustomCloseRedirect={handleCustomCloseRedirect}
      />
      <NewConfirmationDialog
        openConfirmationDialog={openDeleteConfirmationDialog}
        setOpenConfirmationDialog={setOpenDeleteConfirmationDialog}
        title="Delete Confirmation"
        message="Are you sure you want to delete this entry/exit gate?"
        confirmButtonText="Delete"
        handleCustomCloseRedirect={handleDeleteConfirm}
      />
      <Prompt
        when={allowPrompt}
        message={(location, action) => {
          setPathName(location.pathname)
          setOpenConfirmationDialog(true)
          return reDirect
        }}
      />
      <Grid
        container
        justify="space-between"
        alignContent="center"
        alignItems="center"
        style={{ marginBottom: "14px" }}
      >
        <Adm.Breadcrumb list={BreadcrumbList} />
      </Grid>
      <Divider />
      <br />
      <FirstEleDetails
        isWriteAllowed={isWriteAllowed}
        isDeleteAllowed={isDeleteAllowed}
        turnstileDetails={turnstileDetails}
        handleInputChange={handleInputChange}
        handleInputDropdownChange={handleInputDropdownChange}
        dropDownList={dropDownList}
        handleDedupeModal={handleDedupeModal}
        discardChangesOfFirstEle={discardChangesOfFirstEle}
        editApi={editApi}
        setAlertType={setAlertType}
        setAlert={setAlert}
        setAlertMessage={setAlertMessage}
        setLoading={setLoading}
        disableField={
          turnstileDetails?.locationType === "Decommission" ? true : false
        }
        setAllowPromptCheck={setAllowPromptCheck}
        setAllowPrompt={setAllowPrompt}
        setSelectedLocationList={setSelectedLocationList}
        deviceMapped={Boolean(turnstileDetails?.device_mapped)}
        deleteLoading={deleteLoading}
        onDeleteClick={() => setOpenDeleteConfirmationDialog(true)}
        onDeleteDisabledClick={showMappedDevicesError}
      />
      <br />
      <Adm.ButtonUI
        typeView={"secondary"}
        title="BACK TO LIST"
        onClick={() => {
          history.push(
            `/${userProfileDetails?.roleType}/autonomous-store/sdc/turnstile`
          )
        }}
      />
      <StyledDialog
        open={isDedupeOpen}
        onClose={handleDedupeClose}
        aria-labelledby="form-dialog-title"
        maxWidth="xl"
        style={{
          position: "fixed",
        }}
      >
        <HierarchyMapping
          lookupType="location"
          isLookUp
          handleCloseLookUp={handleDedupeClose}
          handleLookUpPrimaryAction={onDialogSubmit}
          isWriteAllowed={true}
          hideCheckBoxAll={true}
          sdcFilter={[
            ...sdcFilter,
            {
              field: "storeType.name",
              operator: "eq",
              value: ["Autonomous Store", ""],
            },
          ]}
          selectedItems={selectedLocationList}
          ShowCheckBox={false}
        />
      </StyledDialog>
      {alert ? (
        <Adm.SnackBar
          makeValuesToDefault={true}
          onCloseHandlerToMakeDefaultValues={onCloseHandlerToMakeDefaultValues}
          open={true}
          message={alertMessage}
          type={alertType}
        />
      ) : null}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    createTurnstile: state.adminReducer.smartDeviceCreateApi.createTurnstile,
  }
}

const mapDispatchToProps = () => {
  return {
    setSmartDeviceApiSuccessToggle: setSmartDeviceApiSuccessToggle,
  }
}

export default connect(mapStateToProps, mapDispatchToProps())(EditTurnstile)
